import { render } from "./HeaderImage.vue?vue&type=template&id=86b8db50"
import script from "./HeaderImage.vue?vue&type=script&lang=js"
export * from "./HeaderImage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__